import * as Sentry from '@sentry/browser';

export default {
    methods: {
        catchError(title, description, response) {
            this.$store.dispatch('notifications/add', {
                color: 'danger',
                title,
                description,
            });

            if (process.env.NODE_ENV === 'development') {
                throw response;
            }

            Sentry.captureEvent({
                message: `${title}: ${description}`,
                extra: {
                    response,
                },
            });
        },

        catchResponseWithDialog(title, data, response) {
            if (process.env.NODE_ENV === 'development') {
                throw response;
            }

            const eventId = Sentry.captureEvent({
                message: title,
                level: Sentry.Severity.Error,
                extra: { data, response },
            });

            Sentry.showReportDialog({
                eventId,
                title,
                subtitle: 'Ein Administrator wurde automatisch benachrichtigt.',
                subtitle2: 'Füllen Sie die nachfolgenden Felder aus, um von uns kontaktiert zu werden.',
                successMessage: 'Besten Dank. Sie werden so schnell wie möglich kontaktiert.',
            });
        },
    },
};
